function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dollar-eyes"
}, /*#__PURE__*/React.createElement("path", {
  d: "M512,256c0,141.38-114.64,256-256,256S0,397.39,0,256,114.61,0,256,0,512,114.61,512,256Z",
  fill: "#ffd764"
}), /*#__PURE__*/React.createElement("path", {
  d: "M235,193.56a85.41,85.41,0,1,1-85.39-85.4A85.37,85.37,0,0,1,235,193.56Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.27,217c0-17.66-11.48-23.1-26-30l-7.87-3.74c-14.55-6.89-15.89-8.06-15.89-14,0-10.43,12.32-11.24,16.08-11.24,4.72,0,15.7,1.1,15.7,11.24a8.82,8.82,0,1,0,17.63,0c0-14.56-9.59-25-24.53-27.94V133a8.82,8.82,0,1,0-17.63,0v8.34c-15,3-24.89,13.6-24.89,27.92,0,17.67,11.48,23.1,26,30l7.89,3.73c14.57,6.91,15.91,8.08,15.91,14,0,10.26-12.3,11.07-16.06,11.07-4.84,0-16.08-1.08-16.08-11.07a8.82,8.82,0,0,0-17.64,0c0,14.5,9.74,24.89,24.89,27.8v9.38a8.82,8.82,0,1,0,17.63,0v-9.38C173.53,241.85,183.27,231.47,183.27,217Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277,193.56a85.41,85.41,0,1,0,85.41-85.4A85.38,85.38,0,0,0,277,193.56Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.13,217c0-17.66-11.47-23.1-26-30l-7.87-3.72c-14.56-6.89-15.9-8.08-15.9-14,0-10.43,12.31-11.25,16.09-11.25,4.72,0,15.68,1.11,15.68,11.25a8.82,8.82,0,1,0,17.64,0c0-14.56-9.59-25-24.51-27.95V133a8.82,8.82,0,1,0-17.64,0v8.34c-15,3-24.9,13.59-24.9,27.92,0,17.67,11.48,23.1,26,30l7.86,3.73c14.58,6.9,15.91,8.08,15.91,14,0,10.26-12.28,11.07-16,11.07-4.83,0-16.09-1.08-16.09-11.07a8.82,8.82,0,0,0-17.64,0c0,14.5,9.73,24.89,24.9,27.78v9.4a8.82,8.82,0,0,0,17.64,0v-9.37C386.41,241.85,396.13,231.46,396.13,217Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256,450.76A133.82,133.82,0,0,1,122.54,326.91h266.9A133.89,133.89,0,0,1,256,450.76Z",
  fill: "#fa645a"
}));

function SvgWon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dollar-eyes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWon);
export default __webpack_public_path__ + "static/media/won.58ae80f0.svg";
export { ForwardRef as ReactComponent };